export default __webpack_public_path__ + "static/media/image.inspire-academy.cefc4eea.png";